import { UserProfileApps } from 'common/types/Entities';

import { _request,APIBaseResponse, APIMethod } from '..';

const USERS_PATH_PREFIX = '/users';
const USER_APP_PATH_PREFIX = 'applicationsuites';

export type APIUserProfileAppsGetListParams = {
    userId: string
};

export type APIUserProfileAppsGetListResponse = APIBaseResponse<Array<UserProfileApps>>;

export const APIUserProfileAppsGet: APIMethod<APIUserProfileAppsGetListParams, APIUserProfileAppsGetListResponse> = params => {
    return _request('GET', `${USERS_PATH_PREFIX}/${params.userId}/${USER_APP_PATH_PREFIX}`);
};
